export default __webpack_public_path__ + "static/media/network_opportunities.cd735b9d.svg";